import React, { useEffect } from 'react';
import { Row, Col, Form, Popover, OverlayTrigger, Button } from 'react-bootstrap';
import { useImmer } from "use-immer";
import moment from 'moment-business-days';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import FormControls from '../../../controls/formControls';

const CodingEventForm = (props) => {
    const formHandler = props.formHandler;
    const [codingUsers, setCodingUsers] = useImmer([]);

    useEffect(() => {
        const users = props.refData.users.map((user) => { return { "id": user.id, "name": user.fullName, "isUser": user.isUser } });
        setCodingUsers(users);
    }, [props.refData.users]);

    const getContactInfo = (id) => {
        var result = props.refData.contacts.filter(obj => {
            return obj.id === id;
        });
        if (result.length > 0) {
            return (
                <> {result[0].fullName} <br /> {result[0].emailAddress} <br /> {result[0].phoneNumber}</>
            );
        }
        return <> Undefined contact<br />&nbsp;<br />&nbsp;</>;
    }

    const getContactPopover = (id) => {
        var result = props.refData.contacts.filter(obj => {
            return obj.id === id;
        });
        if (result.length > 0) {
            return (
                <Popover id="contactPopover">
                    <Popover.Title as="h3"><span className="mr-auto">{result[0].fullName}</span> <FontAwesomeIcon icon={faEnvelope} className={result[0].isUser ? "float-right givemethefinger text-primary" : "float-right givemethefinger text-primary d-none"  } /></Popover.Title>
                    <Popover.Content>
                        <a href={"mailto: " + result[0].emailAddress}>{result[0].emailAddress}</a> <br /> {result[0].phoneNumber}
                    </Popover.Content>
                </Popover>
            );
        }
        return <Popover id="contactPopover">
                   <Popover.Title as="h3">Undefined contact</Popover.Title>
               </Popover>;
    }

    const getContactName = (id) => {
        var result = props.refData.contacts.filter(obj => {
            return obj.id === id;
        });
        if (result.length > 0) {
            return (
                result[0].fullName
            );
        }
        return "Undefined contact";
    }

    const processClinicianName = (value) => {
        const names = value.split(' ');
        let returnValues = { firstName: '', lastName: '' }

        if (names.length === 1) {
            returnValues.firstName = names[0];
        } else if (names.length === 2) {
            returnValues.firstName = names[0];
            returnValues.lastName = names[1];
        } else if (names.length > 2) {
            returnValues.firstName = names[0];
            names.splice(0, 1);
            returnValues.lastName = names.join(' ');
        }
        return returnValues;
    }

    const addClinician = (value) => {
        //alert(value);
        let model = processClinicianName(value);
        model.state = 100;
        model.clinicalManager = false;
        model.tenantId = formHandler.values.accountId;

        props.showModal({
            open: true,
            model: model,
            closeModal: props.hideModal,
            updateClinician: (value) => {
                props.formHandler.setFieldValue("clinicianId", value.id, true)
                props.addToRefData('clinicians', value)
            }
        }, 'addUpdateClinician')
    }

    const addClinicalManager = (value) => {
        //alert(value);
        let model = processClinicianName(value);
        model.state = 100;
        model.clinicalManager = true;
        model.tenantId = formHandler.values.accountId;

        props.showModal({
            open: true,
            model: model,
            closeModal: props.hideModal,
            updateClinician: (value) => {
                props.formHandler.setFieldValue("clinicalManagerId", value.id, true)
                props.addToRefData('clinicalManagers', value)
            }
        }, 'addUpdateClinician')
    }

    return (
        <>
            <Row>
                <Form.Group as={Col} lg="3" md="6">
                    <Form.Label>Customer Name</Form.Label>
                    <div>{formHandler.values['customerAccountName']}</div>
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="LOB"
                        name="lineOfBusinessId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("lineOfBusinessId", val, true)
                        }}
                        options={[{ id: 0, name: "Select LOB..." }, { id: 1, name: "Home Health" }, { id: 2, name: "Hospice" }]}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.DropdownDisplayList
                        label="Customer Contact"
                        name="customerContactId"
                        variant="secondary"
                        //addElement={() => showModal({
                        //    open: true,
                        //    message: "Click \"Alert Me\" to take your action",
                        //    title: "Action Required!",
                        //    hideModal: hideModal,
                        //    actionName: "Alert Me!",
                        //    action: () => { window.alert('Action was taken.') }
                        //}, 'ActionModal')}
                        customButton={
                            <OverlayTrigger trigger="click" placement="bottom" rootClose="true" overlay={getContactPopover(formHandler.values.customerContactId)}>
                                <Button variant="outline-secondary" style={{ "textAlign": "left" }}>{getContactName(formHandler.values.customerContactId)}</Button>
                            </OverlayTrigger>
                        }
                        formHandler={formHandler}
                        valueField="id"
                        displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                        //displaySelected={(values) => getContactName(values.customerContactId)}
                        options={props.refData.contacts} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Billable"
                        name="isBillable"
                        variant="secondary"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} lg="6" md="6">
                    <FormControls.Textarea
                        rows={2}
                        label="Description"
                        name="description"
                        formHandler={formHandler} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SearchSelectbox
                        label="Clinical Manager"
                        name="clinicalManagerId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onCreate={addClinicalManager}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("clinicalManagerId", val, true)
                        }}
                        options={props.refData.clinicalManagers}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SearchSelectbox
                        label="Clinician"
                        name="clinicianId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onCreate={addClinician}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("clinicianId", val, true)
                        }}
                        options={props.refData.clinicians}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Coding Event Queue"
                        name="codingEventQueueId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("codingEventQueueId", val, true)
                        }}
                        options={props.refData.codingEventQueues}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Priority"
                        name="eventPriorityId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("eventPriorityId", val, true)
                        }}
                        options={props.refData.priorities}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <Form.Label>Received On</Form.Label>
                    <Form.Control placeholder="" name="receivedOn" id="receivedOn" readOnly plaintext value={moment(formHandler.values.receivedOn).format('MM/DD/YYYY h:mm a')} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <Form.Label>Due By</Form.Label>
                    <Form.Control placeholder="" readOnly plaintext name="dueBy" id="dueBy" value={formHandler.values.dueBy !== null ? moment(formHandler.values.dueBy).format('MM/DD/YYYY h:mm a') : "Pending"} />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Event Status"
                        name="statusId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("statusId", val, true)
                        }}
                        options={props.refData.statuses}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.Textarea
                        rows="2"
                        label="Status Reason"
                        name="statusReason"
                        formHandler={formHandler} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Service Requested"
                        name="serviceRequestId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        defaultLabel="Select service ..."
                        showDefault
                        onChange={(e) => {
                            let val = parseInt(e.target.value);
                            val = val == 0 ? null : val;
                            formHandler.setFieldValue("serviceRequestId", val, true)
                            formHandler.setFieldValue("dueBy", null, true)
                        }}
                        options={props.refData.services}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Assigned To"
                        name="assignedToId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        defaultLabel="Select assignement ..."
                        showDefault
                        onChange={(e) => {
                            let val = parseInt(e.target.value);
                            val = val == 0 ? null : val;
                            formHandler.setFieldValue("assignedToId", val, true)
                        }}
                        options={codingUsers}
                    />
                </Form.Group>
            </Row>
            <Row>


            </Row>
        </>
    )
}

export default CodingEventForm;